/** Las secciones cuyo retrato suelto es la cara del negocio. */
export const PORTRAIT_CATEGORIES = new Set(['contact', 'map', 'hero', 'cta', 'about']);
const slotOf = (node) => (typeof node.aiSlot === 'string' ? node.aiSlot : '');
/** Pone `portrait` en los retratos sueltos de estos nodos, o los quita si es `null`. */
export function placeBusinessPortrait(roots, portrait, name) {
    const insideList = (path) => path.some((node) => /^repeat\.(item|list)/.test(slotOf(node)));
    const visit = (node, path) => {
        if (node.type === 'image' && slotOf(node).startsWith('media.avatar') && !insideList(path)) {
            if (!portrait)
                return false;
            const image = node;
            image.src = portrait.url;
            image.alt = name;
            return true;
        }
        node.children = node.children.filter((child) => visit(child, [...path, node]));
        return true;
    };
    roots.forEach((root) => visit(root, []));
    return roots;
}
/** El retrato suelto que ya lleva una sección, si lleva uno. */
export function businessPortraitIn(roots) {
    let found = null;
    const visit = (node, path) => {
        if (found)
            return;
        const src = node.src;
        if (node.type === 'image' && slotOf(node).startsWith('media.avatar') && typeof src === 'string' && src && !path.some((item) => /^repeat\.(item|list)/.test(slotOf(item)))) {
            found = src;
            return;
        }
        node.children.forEach((child) => visit(child, [...path, node]));
    };
    roots.forEach((root) => visit(root, []));
    return found;
}
//# sourceMappingURL=businessPortrait.js.map